export default {
  home: {
    hero: {
      title: 'Telecamere di sicurezza e sistemi di allarme per privati e aziende',
      subtitle: 'SSG Signaltechnik progetta, installa e gestisce moderni sistemi di videosorveglianza e allarme in tutta la regione Reno-Meno: da Hainburg passando per Offenbach, Francoforte e Hanau fino a Darmstadt e Groß-Gerau. Su misura per la vostra proprietà, le vostre esigenze e le aree da proteggere davvero.',
      ctaPrimary: 'Richiedi una prima consulenza gratuita',
      ctaSecondary: 'Avvia il pianificatore di telecamere',
    },
    trust: {
      '0': 'Progettazione individuale',
      '1': 'Installazione professionale',
      '2': 'Configurazione dell’app',
      '3': 'Assistenza personale',
      '4': 'Privati e aziende',
    },
    service: {
      eyebrow: 'Il nostro approccio',
      title: 'Molto più che montare telecamere',
      lead: 'Ogni immobile è diverso. Per questo analizziamo a fondo la vostra situazione prima di proporre una sola telecamera. Il servizio completo comprende:',
      steps: {
        '0': 'Analizzare esigenze e immobile',
        '1': 'Scegliere tipo di telecamera e angolo di visione',
        '2': 'Verificare eventuali angoli ciechi',
        '3': 'Pianificare cablaggio, rete e registrazione',
        '4': 'Montare e orientare a regola d’arte',
        '5': 'Configurare app e accesso remoto',
        '6': 'Istruire il cliente in modo chiaro',
        '7': 'Gestire l’impianto su richiesta',
      },
      more: 'Scopri tutti i servizi',
    },
    solutions: {
      eyebrow: 'Tipi di immobile',
      title: 'Soluzioni per ogni proprietà',
      lead: 'Che si tratti di una casa, di un negozio o di un capannone di produzione: troviamo la soluzione giusta per le vostre esigenze.',
      filter: { alle: 'Tutti', privat: 'Privato', gewerbe: 'Azienda', innen: 'Interno', aussen: 'Esterno', neu: 'Nuovo impianto' },
      more: 'Scopri di più',
      viewAll: 'Vedi tutte le soluzioni',
    },
    area: {
      eyebrow: 'Area di intervento',
      title: 'Telecamere e allarmi in tutta la regione Reno-Meno',
      lead: 'Dalla nostra sede di Hainburg copriamo l’intera area metropolitana: Francoforte, Offenbach, Hanau, Darmstadt, Groß-Gerau e tutti i comuni limitrofi. Progettazione, installazione e assistenza della vostra telecamera o del vostro allarme, sempre in modo personale e sul posto.',
      viewAll: 'Vedi tutte le aree di intervento',
    },
    tech: {
      eyebrow: 'Progettazione tecnica',
      title: 'La tecnologia giusta per l’obiettivo giusto',
      lead: 'Non contano solo i megapixel. Un buon impianto nasce dall’interazione di molti fattori.',
      points: {
        '0': { title: 'Interno o esterno', desc: 'Umidità, intemperie e temperatura determinano la scelta della telecamera.' },
        '1': { title: 'Luce e condizioni notturne', desc: 'Soluzioni giorno/notte e a bassa luminosità per ogni situazione di luce.' },
        '2': { title: 'Panoramica o dettaglio', desc: 'Grandangolo per la vista d’insieme o tele per volti e targhe.' },
        '3': { title: 'Distanza e altezza di montaggio', desc: 'Più in alto e più lontano, maggiore risoluzione e obiettivo migliore necessari.' },
        '4': { title: 'Angolo di visione e obiettivo', desc: 'Focale fissa, varifocale o motorizzata, a seconda dello scopo.' },
        '5': { title: 'Registrazione e archiviazione', desc: 'Registratore locale con archiviazione su disco secondo necessità.' },
        '6': { title: 'Accesso via app', desc: 'Vista live e riproduzione da smartphone, a seconda del sistema.' },
        '7': { title: 'Notifiche eventi', desc: 'Messaggi push in caso di movimento o eventi definibili, a seconda del sistema.' },
        '8': { title: 'Espandibilità', desc: 'Gli impianti esistenti possono di solito essere ampliati con altre telecamere.' },
      },
    },
    process: {
      eyebrow: 'Processo',
      title: 'Come si svolge il vostro progetto',
      lead: 'Dalla prima richiesta all’impianto finito: trasparente e personale.',
      steps: {
        '0': { title: 'Primo colloquio', desc: 'Parliamo delle vostre esigenze, del vostro immobile e delle aree da monitorare.' },
        '1': { title: 'Sopralluogo e progettazione', desc: 'Appuntamento in loco per analizzare luce, angoli, punti di montaggio e cablaggio.' },
        '2': { title: 'Offerta individuale', desc: 'Ricevete un’offerta trasparente con la tecnologia adatta e un chiaro ambito di servizi.' },
        '3': { title: 'Installazione e configurazione', desc: 'Montaggio professionale, collegamento di rete, configurazione del registratore e dell’app.' },
        '4': { title: 'Formazione e assistenza', desc: 'Imparate a usare l’impianto. Siamo al vostro fianco, anche dopo.' },
      },
    },
    refs: {
      eyebrow: 'Progetti di riferimento',
      title: 'Progetti realizzati',
      lead: 'Una selezione del nostro portfolio: dalla casa privata agli impianti commerciali.',
      viewAll: 'Scopri tutte le soluzioni',
      items: {
        '0': { label: 'Casa privata – abitazione unifamiliare', desc: 'Impianto completo con 6 telecamere, NVR e collegamento all’app' },
        '1': { label: 'Commercio – boutique', desc: 'Area vendita e magazzino con 4 telecamere e visione notturna' },
        '2': { label: 'Logistica – magazzino', desc: 'Sorveglianza di grandi superfici con grandangolo e PTZ' },
        '3': { label: 'Studio – accettazione medica', desc: 'Sorveglianza interna discreta con mascheramento privacy' },
        '4': { label: 'Immobiliare – condominio', desc: 'Ingresso e aree esterne con segnaletica' },
      },
    },
    care: {
      eyebrow: 'Manutenzione e assistenza',
      title: 'SSG Care',
      lead: 'La vostra tecnologia di telecamere deve funzionare in modo affidabile nel tempo. Con SSG Care ottenete un abbonamento di assistenza flessibile: disdetta mensile o con durata concordata.',
      list: {
        '0': 'Controlli periodici del sistema e aggiornamenti firmware',
        '1': 'Assistenza con problemi di app e accesso',
        '2': 'Aiuto nel cambio di smartphone',
        '3': 'Verifica di registrazione e archiviazione',
        '4': 'Gestione prioritaria su accordo',
      },
      cta: 'Scopri SSG Care',
    },
    planner: {
      eyebrow: 'Strumento interattivo',
      title: 'Il pianificatore di telecamere SSG',
      lead: 'Disegnate stanze o superfici, segnate le zone di sorveglianza importanti e testate le possibili posizioni delle telecamere con i coni di visione. Il risultato è una pianificazione preliminare non vincolante per il vostro colloquio con noi.',
      list: {
        '0': 'Disegnare stanze e pareti',
        '1': 'Posizionare le icone delle telecamere con trascinamento',
        '2': 'Coni di visione ruotabili con valutazione della copertura',
        '3': 'Segnare zone di sorveglianza e privacy',
        '4': 'Inviare il risultato come richiesta o stamparlo',
      },
      cta: 'Avvia il pianificatore di telecamere',
    },
    faq: {
      eyebrow: 'Domande frequenti',
      title: 'Cosa ci chiedono spesso i clienti',
      viewAll: 'Vedi tutte le domande',
      items: {
        '0': { question: 'Quante telecamere mi servono?', answer: 'Dipende dalle dimensioni dell’immobile, dalle aree da monitorare e dal livello di dettaglio desiderato. Dopo un primo colloquio e un sopralluogo elaboriamo una proposta individuale.' },
        '1': { question: 'Posso vedere le telecamere sullo smartphone?', answer: 'Sì, con la maggior parte dei sistemi moderni è possibile l’accesso tramite app. Configuriamo la connessione dell’app direttamente durante l’installazione.' },
        '2': { question: 'Le telecamere funzionano al buio?', answer: 'Sì, per esterni e interni poco illuminati esistono telecamere giorno/notte e a bassa luminosità con visione notturna a infrarossi o a colori.' },
        '3': { question: 'Quanto costa un impianto di telecamere?', answer: 'Il costo dipende dal numero di telecamere, dall’immobile, dal cablaggio e dalle funzioni desiderate. Elaboriamo volentieri un’offerta individuale e non vincolante.' },
      },
    },
    cta: {
      title: 'Scopriamo insieme quale soluzione si adatta alla vostra proprietà.',
      lead: 'Chiamateci, scriveteci o iniziate direttamente con il pianificatore di telecamere. Vi risponderemo tempestivamente.',
      primary: 'Richiedi una prima consulenza gratuita',
      secondary: 'Avvia il pianificatore di telecamere',
    },
  },
  company: {
    solutions: {
      home: { title: 'Casa e proprietà', description: 'Dalla porta di casa al garage: sorveglianza discreta per la vostra abitazione.' },
      retail: { title: 'Commercio e ristorazione', description: 'Cassa, ingresso e magazzino: protetti in modo professionale.' },
      office: { title: 'Ufficio e studio', description: 'Reception, corridoi e aree sensibili: progettati nel rispetto della privacy.' },
      warehouse: { title: 'Magazzino e logistica', description: 'Sorveglianza di grandi superfici con grandangolo e visione notturna.' },
      workshop: { title: 'Officina e artigianato', description: 'Telecamere robuste per ambienti difficili: capannoni e aree esterne.' },
      apartment: { title: 'Condomini e immobili', description: 'Ingressi, scale e aree esterne, per inquilini e proprietari.' },
    },
  },
};